export default __webpack_public_path__ + "static/media/EnikoProfile-edit-3-Frame-Right.525ea800.jpg";